import { useContext, useEffect, useState } from "react";
import TableDependenceData from "../components/tableDependenceData";
import { Dependence, User, UserPermissionType } from "../interfaces/type";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getDependence } from "../services/dependence.service";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { AuthContext } from "../providers/auth.provider";

const DependenceView = () => {
  const [listDependence, setListDependence] = useState<Partial<Dependence>[]>([]);
  const [listDependenceFilter, setListDependenceFilter] = useState<Partial<Dependence>[]>([]);
  const [searchText, setSearchText] = useState<string>("TODO")

  const { auth, loginAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.user?.userPermission) {
      if (
        !auth.user?.userPermission?.find(
          (f) => f.type == UserPermissionType.CONFIG && f.allow == true
        )
      ) {
        toast.error("NO TIENE PERMISOS PARA ESTA ACCION");
        navigate("/dashboard");
      }
    }
  }, [auth.user]);

  const { data, isLoading, error } = useQuery<Partial<Dependence>[]>(
    ["dependence"], // <-----
    getDependence
  );
  const queryClient = useQueryClient();

  //const { result, error, loading } = useApi("/user")

  useEffect(() => {
    if (data) {
      setListDependence(data);
      setListDependenceFilter(data.filter((item) => {
      return (
        (((searchText ?? "TODO") == "TODO") ? true : item.place == searchText)
      );
    }));
    }
  }, [data]);

  const handleSearch = (s: string) => {
    const newData = listDependence.filter((item) => {
      return (
        (((s ?? "TODO") == "TODO") ? true : item.place == s)
      );
    });
    setSearchText(s)
    setListDependenceFilter(newData);
  };

  const handleChangeListDependence = (dependence: Partial<Dependence>) => {
    const dependences = listDependence.filter((u) => u.id !== dependence.id);
    setListDependence([...dependences]);
    setListDependenceFilter([...dependences.filter((item) => {
      return (
        (((searchText ?? "TODO") == "TODO") ? true : item.place == searchText)
      );
    })]);
  };

  if (isLoading) return <>CARGANDO</>;

  return (
    <div className="w-full h-full p-2 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8">
      <div className="w-full flex flex-col md:flex-row my-2 border-b">
        <div className="w-full md:w-3/4 flex flex-row items-center">
          <div className="text-xl font-bold">Dependencias</div>
          <div className="text-sm mx-5 text-gray-500">{`Total: ${listDependence.length}`}</div>
        </div>
      </div>
      <TableDependenceData
        data={listDependenceFilter}
        handleSearch={handleSearch}
        handleChangeListDependence={handleChangeListDependence}
      />
    </div>
  );
};

export default DependenceView;
